import { reduxKey } from './constants';
export const getEditorSlice = (state, editorId)=>state[reduxKey] && state[reduxKey][editorId] || {};
export const isBusy = (state, editorId)=>{
    var _getEditorSlice_isBusy;
    return (_getEditorSlice_isBusy = getEditorSlice(state, editorId)['isBusy']) !== null && _getEditorSlice_isBusy !== void 0 ? _getEditorSlice_isBusy : false;
};
export const getPublishResult = (state, editorId)=>getEditorSlice(state, editorId)['publishResult'];
export const isError = (state, editorId)=>getEditorSlice(state, editorId)['isError'];
export const getErrorMsg = (state, editorId)=>getEditorSlice(state, editorId)['errorMsg'];
export const getShouldResetEditor = (state, editorId)=>getEditorSlice(state, editorId)['shouldResetEditor'];
export const getIsFocusRequested = (state, editorId, defaultValue = false)=>{
    const focus = getEditorSlice(state, editorId)['isFocusRequested'];
    if (focus === undefined) {
        return defaultValue;
    }
    return focus;
};

//# sourceMappingURL=selectors.js.map